import React, { useEffect } from 'react';
import IvoriMethodEsatPage from '../../features/method/IvoriMethodEsatPage';

export default function IvoriMethodEsatRoute() {
  useEffect(() => {
    document.title = "The IVORI Method — Sweller, Chi, Pólya & Lakatos | Pathbuddy";
    window.scrollTo(0, 0);
  }, []);

  return <IvoriMethodEsatPage />;
}